module.exports = __webpack_public_path__ + "media/images/steps/step_8-fbe0ed32d575162ec179453f78e13b99.svg";